module.exports = __webpack_public_path__ + "static/img/净水器banner2.7ae275bc.png";